module.exports = __webpack_public_path__ + "static/img/teritory-map.d71fa889.png";